import { Glyphicon } from 'react-bootstrap';
import Tooltip from 'components/tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import theme from 'styles/theme';
import Badge from 'components/badge/Badge';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { NotAvailableWrapper } from './NotAvailable.styles';

const NotAvailable = ({
  integrationId,
}: {
  integrationId?: IntegrationEnum;
}) => {
  const { t } = useTranslation();

  return (
    <NotAvailableWrapper>
      <Badge
        backgroundColor={theme.colors.gray600}
        data-testid="not-available-badge"
      >
        {t('pageIntegrations.table.notAvailable')}
      </Badge>

      <Tooltip
        text={t('pageIntegrations.table.notAvailableTooltip', {
          context: integrationId,
        })}
        id="not-available-tooltip"
      >
        <Glyphicon glyph="info-sign" data-testid="not-available-tooltip" />
      </Tooltip>
    </NotAvailableWrapper>
  );
};

export default NotAvailable;
